export default class AccordionCareersModule {
    constructor(element) {
        this.$wrapper = element;
        this.items = this.$wrapper.querySelectorAll('.accordion-careers__item');

        if (!this.items.length) return;

        this.bindEvents();
        this.syncInitialState();
    }

    syncInitialState() {
        this.items.forEach((item) => {
            const trigger = item.querySelector('.accordion-careers__trigger');
            const panel = item.querySelector('.accordion-careers__panel');
            const isOpen = item.classList.contains('is-open');

            if (!trigger || !panel) return;

            trigger.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
            panel.style.maxHeight = isOpen ? `${panel.scrollHeight}px` : null;
        });
    }

    bindEvents() {
        this.items.forEach((item) => {
            const trigger = item.querySelector('.accordion-careers__trigger');
            const panel = item.querySelector('.accordion-careers__panel');

            if (!trigger || !panel) return;

            trigger.addEventListener('click', () => {
                const isOpen = item.classList.contains('is-open');

                this.items.forEach((otherItem) => {
                    const otherTrigger = otherItem.querySelector('.accordion-careers__trigger');
                    const otherPanel = otherItem.querySelector('.accordion-careers__panel');

                    otherItem.classList.remove('is-open');
                    if (otherTrigger) otherTrigger.setAttribute('aria-expanded', 'false');
                    if (otherPanel) otherPanel.style.maxHeight = null;
                });

                if (!isOpen) {
                    item.classList.add('is-open');
                    trigger.setAttribute('aria-expanded', 'true');
                    panel.style.maxHeight = `${panel.scrollHeight}px`;
                }
            });
        });
    }
}
